import { FC } from 'react';

// TODO: Remove when all pages for routes are completed
const UnderDevelopment: FC = () => {
  return <div>This page is still under development</div>;
};

export default UnderDevelopment;
